<app-modal-dialog #modal_source
    title="{{ (selectedTag.id == '0' || selectedTag.id == null || selectedTag.id == ''? 'sources.create' : 'sources.edit') | translate }}"
    modalId="source-modal" okText="{{ 'sources.save' | translate }}" [isValid]="isValid()"
    (onClose)="modalClosed($event)">

    <div class="form-col">
        <input [(ngModel)]="selectedTag.companyTitle" type="text" class="ihost-control w-100 mb-2"
            placeholder="{{ 'sources.placeholders.name' | translate }}." />
        <input [(ngModel)]="selectedTag.contactSurname" #contactSurnameName="ngModel" type="text"
            class="ihost-control w-100 mb-2" placeholder="{{ 'sources.placeholders.surname' | translate }}" />
        <input [(ngModel)]="selectedTag.contactName" #contactName="ngModel" type="text" class="ihost-control w-100 mb-2"
            placeholder="{{ 'sources.placeholders.contactName' | translate }}" />
        <input [(ngModel)]="selectedTag.contactMail" #contactEmail="ngModel" type="text"
            class="ihost-control w-100 mb-2" placeholder="{{ 'sources.placeholders.contactEmail' | translate }}" />
        <input [(ngModel)]="selectedTag.contactTelephone" #contactPhone="ngModel" type="text"
            class="ihost-control w-100 mb-2" placeholder="{{ 'sources.placeholders.contactPhone' | translate }}" />
    </div>
</app-modal-dialog>